// SPDX-License-Identifier: LicenseRef-Proprietary

import type { PotentialInputSource } from '../../../lib/models';

/**
 * Human-readable labels for HTA model input sources
 * Maps internal PotentialInputSource keys to display labels
 */
export const INPUT_SOURCE_LABELS: Record<PotentialInputSource, string> = {
  vaccineEfficacy: "Efficacy",
  waningBoosters: "Waning",
  incidenceEpi: "Incidence",
  costsResourceUse: "Costs",
  utilitiesQoL: "Quality of Life",
  safety: "Safety",
  coverageAdherence: "Coverage",
  modelStructure: "Model Structure",
  none: "General",
};

/**
 * Configuration for AI triage confidence levels
 * Includes icon, text label, and color scheme
 */
export const CONFIDENCE_CONFIG = {
  low: { 
    icon: "", 
    text: "Low confidence", 
    color: "amber" 
  },
  medium: { 
    icon: "", 
    text: "Medium confidence", 
    color: "blue" 
  },
  high: { 
    icon: "", 
    text: "High confidence", 
    color: "green",
    tooltip: "Abstract clearly states study design, population, intervention, outcomes, and results with specific metrics"
  },
} as const;

/**
 * Explanatory tooltips for confidence levels
 */
export const CONFIDENCE_TOOLTIPS = {
  high: "Abstract clearly states study design, population, intervention, outcomes, and results with specific metrics",
  medium: "Abstract provides most key information but may lack specificity or have minor ambiguities",
  low: "Abstract is vague, incomplete, or doesn't clearly state methodology or findings"
};

export type ConfidenceLevel = keyof typeof CONFIDENCE_CONFIG;
